import type * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex min-h-20 w-full max-w-full rounded-2xl border border-black/15 bg-black/5 px-4 py-3 break-words text-text-primary shadow-[inset_0_1.5px_3px_rgba(0,0,0,0.1)] backdrop-blur-md transition-all duration-200 outline-none selection:bg-brand selection:text-text-inverse placeholder:text-text-primary/50 disabled:cursor-not-allowed disabled:opacity-40 md:text-sm dark:border-white/10 dark:bg-black/35 dark:shadow-[inset_0_2px_4px_rgba(0,0,0,0.4)]",
        "hover:bg-black/10 dark:hover:bg-white/5",
        "focus-visible:border-brand/40 focus-visible:ring-4 focus-visible:ring-brand/20 dark:focus-visible:border-brand/50 dark:focus-visible:ring-brand/30",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
